import { toast, ajax as Ajax, isFunction, isArray, isEmpty, isObj, ViewModel, localeLang, localTimeToServer, serverTimeToLocal, getAppReqParam, setUserQueryHistory, formatDatetime, getGlobalStorage, setGlobalStorage } from '@platform/api';
import { moment, isJSON } from '@platform/api';
import { getFunctionDisplay } from '@platform/base';
import {
    _getAllSearchData,
    setSearchPlanName,
} from './methods';
import dayjs from 'dayjs';

let { removeGlobalStorage } = ViewModel;

// =========以下为平台内部使用的方法========================

let OperationOptions = [];
export function setOperationOptionsMultiLang(_multiLang) {
    const multiLang = _multiLang;
    if (isEmpty(OperationOptions) && !isEmpty(_multiLang)) {
        OperationOptions = [
            {
                display: multiLang['page-search-0047'],
                value: '=',
            },
            {
                display: multiLang['page-search-0048'],
                value: '>',
            },
            {
                display: multiLang['page-search-0049'],
                value: '<',
            },
            {
                display: multiLang['page-search-0050'],
                value: 'between',
            },
            {
                display: multiLang['page-search-0051'],
                value: '>=',
            },
            {
                display: multiLang['page-search-0052'],
                value: '<=',
            },
            {
                display: multiLang['page-search-0053'],
                value: '<>',
            },
            {
                display: multiLang['page-search-0054'],
                value: 'like',
            },
            {
                display: multiLang['page-search-0055'],
                value: 'left like',
            },
            {
                display: multiLang['page-search-0056'],
                value: 'right like',
            },
            {
                display: multiLang['page-search-0057'],
                value: 'is null',
            },
            {
                display: multiLang['page-search-0084'],
                value: 'not like',
            },
            {
                display: multiLang['page-search-0085'],
                value: 'is not null',
            },
            {
                display: multiLang['page-search-0102'],
                value: 'not between',
            },
        ];
    }
}
//处理自然时间转多时区和起终点 time 是时间 flage：start 当天0点，end当天24点 假就是不处理
export function naturalTimeHandler(time, flag, isconverttimezones) {
    let format = '';
    switch (flag) {
        case 'start':
            format = 'YYYY-MM-DD HH:mm:ss';
            break;
        case 'end':
            format = 'YYYY-MM-DD HH:mm:ss';
            break;
    }
    const loc = serverTimeToLocal(moment(time), isconverttimezones).format(format);
    const dong8 = localTimeToServer(moment(loc), isconverttimezones).format(format);
    return dong8;

}
/* 处理运算符 */
export function createOperation(data) {
    let newArr = [];
    if (!data) { return newArr; }
    //去掉开头和结尾的@符号
    data = data.replace(/^@+|@$/g, '');
    let o = data.split('@');
    o.forEach(item => {
        for (let i = 0; i < OperationOptions.length; i++) {
            if (item === OperationOptions[i].value) {
                newArr.push(OperationOptions[i]);
                break;
            }
        }
    });
    return newArr;
}
export function _clone(obj) {
    return JSON.parse(JSON.stringify(obj === undefined ? '' : obj));
}

export function getTimezoneOffset() {
    return -1 * new Date().getTimezoneOffset() / 60;
}
//从缓存中获取函数翻译值
export function getFunctionValueFromViewModal(VALUE, context = {}, attrcode) {
    let reslut = _clone(VALUE);
    attrcode = '';//暂时去掉根据attrcode过滤的条件。
    let mainorgVal = context.pk_org || '';
    if (mainorgVal && attrcode === 'pk_org' && Array.isArray(context.permOrgs) && !context.permOrgs.includes(mainorgVal)) {
        mainorgVal = '';
    }
    let obj = {
        '#mainorg#': {
            // 默认主组织
            display: mainorgVal ? context.org_Name : '',
            value: mainorgVal,
        },
        '#DefaultCostRegion#': {
            // 默认财务成本域
            display: context.defaultCostRegionName || '',
            value: context.defaultCostRegionPk || '',
        },
        '#DefaultCreditCtlRegion#': {
            //默认信用域
            display: context.defaultCreditCtlRegionName || '',
            value: context.defaultCreditCtlRegionPk || '',
        },
        '#accountingbook#': {
            //默认账簿
            display: context.defaultAccbookName || context.accountingBookName || '',
            value: context.defaultAccbookPk || context.accountingBookPk || '',
        },
        '#operator#': {
            //当前操作员
            display: context.userName || '',
            value: context.userId || '',
        },
        '#currentgroup#': {
            //当前集团
            display: context.groupName || '',
            value: context.groupId || '',
        },
        '#DefaultLiactCostrgFunction#': {
            //默认利润中心成本域
            display: context.defaultCenterContentName || '',
            value: context.defaultCenterContentPK || '',
        },
        "#DefaultCostrgOrLiactCostrgFunc#": {
            //默认成本域
            display: context.defaultCostRegionName || context.defaultCenterContentName || '',
            value: context.defaultCostRegionPk || context.defaultCenterContentPK || '',
        },
        "#busioperator#": {
            //当前人员
            display: context.defaultPsndocName || '',
            value: context.defaultPsndocPK || '',
        },
        "#rbacdept#": {
            //当前人员所属部门 
            display: context.defaultDeptName || '',
            value: context.defaultDeptPK || '',
        },
        "#globeorg#": {
            //全局  
            display: context.globeName || '',
            value: context.globePK || '',
        },
        "#currperiod#": {
            //当前计划周期 
            display: context.currperiodName || '',
            value: context.currperiodPK || '',
        },
        "#mainaccperiod#": {
            //默认会计期间 
            display: context.mainacceperiodName || '',
            value: context.mainAcceperiodPK || '',
        },
        "#currentaccperiod#": {
            //当前期间 
            display: context.currentAccperiodName || '',
            value: context.currentAccperiodPk || '',
        },
        "#rbacdeptsubincluded#": {
            //用户主职部门及其下级  数组
            display: Array.isArray(context.defaultDeptsubincludedName) ? context.defaultDeptsubincludedName.join(',') : context.defaultDeptsubincludedName || '',
            value: Array.isArray(context.defaultDeptsubincludedPK) ? context.defaultDeptsubincludedPK.join(',') : context.defaultDeptsubincludedPK || '',
        },
        "#firstaccperiod#": {
            //第一个期间 
            display: context.fristAccperiodName || '',
            value: context.fristAccperiodPK || '',
        },
        // "#accountingbook#": {
        //     //默认（总账）账簿 
        //     display: context.accountingBookName || '',
        //     value: context.accountingBookPk || '',
        // },
        "#psndocdeptOrg#": {
            //兼职部门
            display: Array.isArray(context.psndocDeptOrgName) ? context.psndocDeptOrgName.join(',') : context.psndocDeptOrgName || '',
            value: Array.isArray(context.psndocDeptOrgPK) ? context.psndocDeptOrgPK.join(',') : context.psndocDeptOrgPK || '',
        },
        "#rbacdeptpart_v#": {
            //用户主职部门及其兼职部门(版本)
            display: Array.isArray(context.defaultDeptPart_VName) ? context.defaultDeptPart_VName.join(',') : context.defaultDeptPart_VName || '',
            value: Array.isArray(context.defaultDeptPart_VPK) ? context.defaultDeptPart_VPK.join(',') : context.defaultDeptPart_VPK || '',
        },
        "#rbacdeptpartsuperall#": {
            //用户主职部门及兼职部门及其上级部门
            display: Array.isArray(context.rbacdeptpartsuperallName) ? context.rbacdeptpartsuperallName.join(',') : context.rbacdeptpartsuperallName || '',
            value: Array.isArray(context.rbacdeptpartsuperallPk) ? context.rbacdeptpartsuperallPk.join(',') : context.rbacdeptpartsuperallPk || '',
        },
        "#firstaccperiod#": {
            //第一个期间 
            display: context.fristAccperiodName || '',
            value: context.fristAccperiodPK || '',
        },
        "#userorganization#": {
            //用户所属组织 
            display: context.userorganizationName || '',
            value: context.userorganizationPK || '',
        },
        '#rbacdept_v#': {
            //用户所属部门 
            display: context.defaultDept_vName || '',
            value: context.defaultDept_vPK || '',
        },
        "#rbacdeptpart#": {
            //用户主职部门及其兼职部门
            display: Array.isArray(context.defaultDeptPartName) ? context.defaultDeptPartName.join(',') : context.defaultDeptPartName || '',
            value: Array.isArray(context.defaultDeptPartPK) ? context.defaultDeptPartPK.join(',') : context.defaultDeptPartPK || '',
        },
        "#rbacdeptup#": {
            // 上级部门
            display: context.defaultDeptUpName || '',
            value:  context.defaultDeptUpPk || '',
        },
        "#rbacdeptpartsubincluded#": {
            //默认（总账）账簿 
            display: context.rbacdeptpartsubincludedName || '',
            value: context.rbacdeptpartsubincludedPK || '',
        },
        "#rbacdeptandpartsubincluded#": {
            //默认（总账）账簿 
            display: context.rbacdeptandpartsubincludedName || '',
            value: context.rbacdeptandpartsubincludedPK || '',
        },
        '#rbacdeptsupersubincluded#': {
            //用户主职部门上级及其下级部门
            display: Array.isArray(context.rbacdeptsupersubincludedName) ? context.rbacdeptsupersubincludedName.join(',') : context.rbacdeptsupersubincludedName || '',
            value: Array.isArray(context.rbacdeptsupersubincludedPK) ? context.rbacdeptsupersubincludedPK.join(',') : context.rbacdeptsupersubincludedPK || '',
        },
    };

    if (Array.isArray(reslut)) {
        reslut.map(item => {
            if (item.value && item.value.indexOf('#') !== -1) {
                item = obj[item.value] || item;
            } else if (attrcode === 'pk_org' && item.value && Array.isArray(context.permOrgs) && !context.permOrgs.includes(item.value)) {
                item.value = '';
                item.display = '';
            }
            return item;
        });
    } else {
        if (reslut.value && reslut.value.indexOf('#') !== -1) {
            reslut = obj[reslut.value] || reslut;
        } else if (attrcode === 'pk_org' && reslut.value && Array.isArray(context.permOrgs)) {
            let vArray = reslut.value.split(',');
            let DisArray = reslut.display.split(',');
            let filterVal = [];
            let filterDis = [];
            for (let index = 0; index < vArray.length; index++) {
                let el = vArray[index];
                if (context.permOrgs.includes(el)) {
                    filterVal.push(el);
                    filterDis.push(DisArray[index]);
                }
            }
            reslut.value = filterVal.join(',');
            reslut.display = filterDis.join(',');
        }
    }
    return reslut;
}

//初始化查询区需要的数据searchInfo
export function initSearchArea(props, info) {
    let isEdit = info.isEdit;//模板是否改变
    let flag = false;//标识是否是第一次初始化
    info.isWidgetMode = props.isWidgetMode;
    info.moduleId = props.moduleId;
    let meta = props.meta;
    if (!info.isCompleted) {
        let isclosequickquery = meta.isclosequickquery;
        let defaultDisPlay = meta.defaultDisPlay;
        //如果没有高级就一直展开，如果有高级就按照isunfold为true展开
        info.showSearchItems = !meta.isunfold;
        info.showSearchItems = props.showAdvBtn ? info.showSearchItems : false;
        info.showAdvModal = false; // 高级面板的显隐性
        let conditions;
        if (defaultDisPlay && defaultDisPlay !== '00000000000000000000') {
            conditions = Array.isArray(meta.queryschemes) && meta.queryschemes.find(item => item.pk_ncc_queryscheme === defaultDisPlay);
        }
        else if (!isclosequickquery && !defaultDisPlay) {
            conditions = Array.isArray(meta.queryschemes) && meta.queryschemes.find(item => item.isquickqs && item.isprepared === true);
            if (conditions) {
                meta.defaultPrepared = conditions.pk_ncc_queryscheme;
            }
        }
        if (conditions) {
            // 默认方案添加到当前方案
            info.currentPlan = conditions;

            //如果此时模板上新增或删除了某一个字段设置默认，还得进行一次过滤
            let finalSortField = [];
            let schemaSortField = [];
            let metaSortfield = meta.sortField || [];
            let schemaSortObj = {};
            let metaSortObj = {};
            let newAddSortField = [];

            if (
                Array.isArray(meta.queryschemes) &&
                Array.isArray(meta.queryschemesdto)
            ) {
                meta.queryschemesdto.forEach(i => {
                    let queryScheme = i.querySchemeVO;
                    if (
                        i.querySchemeUserVO &&
                        i.querySchemeUserVO.isdefaultdisplay
                    ) {
                        if(queryScheme.sortfield){
                            schemaSortField = queryScheme.sortfield;
                        }
                    }
                });
            }
            schemaSortField.forEach(item => {
                schemaSortObj[item.refcode] = item;
            });
            metaSortfield.forEach(item => {
                metaSortObj[item.refcode] = item;
            });
            schemaSortField.forEach(item => {
                if(Object.keys(metaSortObj).includes(item.refcode)){
                    finalSortField.push(item);
                }
            });

            metaSortfield.forEach(item => {
                if(!Object.keys(schemaSortObj).includes(item.refcode)){
                    newAddSortField.push(item);
                }
            });
            info.currentPlan.sortfield = [...finalSortField, ...newAddSortField];
        } else {
            info.currentPlan = info.defaultPlan;
        }
        info.isDefaultPlan = info.currentPlan.pk_ncc_queryscheme == '001';
        const name123 = info.multiLangOpt.createName123(info.currentPlan);

        //当前语种的name
        info.searchPlanName = info.multiLangOpt.getMultiLangValueFromName123(name123);
    }
    if(isEdit){
        let plan = info.searchPlanCache.find(item => item.pk_ncc_queryscheme == info.currentPlan.pk_ncc_queryscheme);
        info.currentPlan.renderobj4web = plan.renderobj4web;
        initSimpleSnap(props.context, info, info.currentPlan, true, isEdit);
        info.snapshotMap['simple'] = info.currentPlan.renderobj4web_snap;
    }
    // if (info.currentPlan.isMyPlan) {
    //     //查询区模板动态变化的情况
    //     //1.业务在原有的模板基础上增加和删除了字段
    //     //2.业务直接替换了原来的模板的items
    //     let prev = info.currentPlan.renderobj4web;
    //     let next = info.defaultPlan.renderobj4web;
    //     let prevLenth = prev.length;
    //     let nextLenth = next.length;
    //     if (!info.searchKey) {
    //         isEdit = true;
    //     } else if (prevLenth !== nextLenth) {
    //         isEdit = true;
    //     } else {
    //         for (let index = 0; index < prev.length; index++) {
    //             if (prev[index].attrcode !== next[index].attrcode) {
    //                 isEdit = true;
    //                 break;
    //             }
    //         }
    //     }
    //     if (isEdit) {
    //         info.currentPlan.renderobj4web = info.defaultPlan.renderobj4web;
    //     }
    // } else {
    //     //感觉这块逻辑都不会走
    //     let plan = info.searchPlanCache.find(item => item.pk_ncc_queryscheme == info.currentPlan.pk_ncc_queryscheme);
    //     //说明查询区的查询方案变了
    //     if (!plan) {
    //         info.currentPlan = info.defaultPlan;
    //     }
    // }
    
    //初始化并恢复快照

    if (!info.hasOwnProperty('isCompleted')) {
        info.isCompleted = true;
        flag = true;
    }
    if (flag) {
        isFunction(props.setInitValueEvent) && (props.setInitValueEvent('simple'));
    }

}
// 展开查询方案 并处理成 快照
export function spreadQueryPlan(context, planItems, temItem, isWidgetMode, preSnapMap = {}, level = 0) {
    if (Array.isArray(planItems)) {
        return planItems.map(item => {
            if (Array.isArray(item.children)) {
                item.children = spreadQueryPlan(context, item.children, temItem, isWidgetMode, preSnapMap, ++level);
                return item;
            } else {
                let initialvalue = { value: '', display: '' };
                //如果原来有值，就将值赋给新的快照
                if (preSnapMap[item.attrcode]) {
                    item.initialvalue = preSnapMap[item.attrcode];
                }
                //如果item.initialvalue存在
                if (item.initialvalue && typeof item.initialvalue === "object") {
                    initialvalue = {...item.initialvalue};
                    if(initialvalue.value === undefined){
                        initialvalue.value = "";
                    }
                    if(initialvalue.display === undefined){
                        initialvalue.display = "";
                    }

                }
                let tempItem = temItem[item.attrcode];
                if (tempItem) {
                    if (tempItem.itemtype === 'checkbox_switch') {
                        if (initialvalue.value) {
                            initialvalue.value = true;
                        } else {
                            initialvalue.value = false;
                        }
                    } else if (tempItem.itemtype === 'refer') {
                        let refervalue = getFunctionValueFromViewModal(initialvalue, context, tempItem.attrcode);
                        initialvalue.display = refervalue.display;
                    } else if (tempItem.itemtype === 'residtxt') {
                        let index = tempItem.languageMeta.filter(val => val.languageCode == localeLang)[0]?.index || 1;
                        //这里在看看有没有问题xiqq
                        initialvalue.index = index;
                    }
                    let visible = item.visible === false ? false : true;
                    let isdefault = item.isdefault === false ? false : visible;
                    let operationOptions = (Array.isArray(item.operationOptions) && item.operationOptions.length > 0) ? item.operationOptions : createOperation(tempItem.queryOperateType);
                    let operationSign = '=';
                    if (tempItem.queryOperateType) {
                        operationSign = tempItem.queryOperateType.replace(/^@+|@$/g, '').split('@')[0];
                    }
                    let obj = {
                        attrcode: tempItem.attrcode,
                        refpk: item.refpk || tempItem.attrcode,
                        initialvalue: initialvalue,
                        operationOptions: operationOptions,
                        remove: item.remove !== undefined ? item.remove : !(tempItem.required || tempItem.isfixedcondition || tempItem.nodelete),
                        label: tempItem.label,
                        isfixedcondition: !!tempItem.isfixedcondition,
                        isExtend: item.isExtend !== undefined ? item.isExtend : !!tempItem.isfixedcondition,
                        operationSign: item.operationSign || operationSign || '=',
                        visible: !!isWidgetMode || visible,
                        isdefault: isdefault,
                        itemtype: tempItem.itemtype,
                        isconverttimezones: tempItem.isconverttimezones,
                        metadataProperty: tempItem.metadataProperty,
                        metapath: tempItem.metapath,
                    };
                    if (tempItem.itemtype === 'residtxt') {
                        if (!isEmpty(item.valueMap)) {
                            obj.valueMap = item.valueMap;
                        } else if (initialvalue.value) {
                            obj.valueMap = {};
                            obj.valueMap[item.attrcode + initialvalue.index] = { value: initialvalue.value };
                        }
                    }
                    if(tempItem.itemtype === 'refer'){
                        if(!isEmpty(item.referConfig)){
                            obj.referConfig = item.referConfig;
                        }
                        obj.runWithChildren = item.runWithChildren || false;
                        obj.refurl = item.refurl || '';
                    }
                    // if (tempItem.isfixedcondition && level < 2) {
                    //     obj.visible = false;
                    // }
                    return obj;
                }
            }
        }).filter(obj => obj && obj.visible);
    } else {
        return [];
    }
}
//初始化简单查询快照  切换查询方案的时候falg=false
export function initSimpleSnap(context, info, currentPlan, flag = true, isEdit = false, updateSortField = false) {
    if (!currentPlan) { return; }
    let preSortField = info.sortField;
    let preSortFiledMap = {};
    if (flag && Array.isArray(preSortField)) {
        preSortField.forEach(element => {
            preSortFiledMap[element.refcode] = element;
        });
    }
    if (Array.isArray(currentPlan.sortfield)) {
        info.sortField = currentPlan.sortfield.map(item => {
            if (preSortFiledMap[item.refcode]) {
                let ordertype = preSortFiledMap[item.refcode].ordertype;
                let _checked = preSortFiledMap[item.refcode]._checked;
                return { ...item, ordertype, _checked };
            }
            let _checked = item.ordertype === '0' ? false : item._checked ?? true;
            return { _checked, ...item };
        });
    } else if (Array.isArray(info.defaultPlan.sortField) && !updateSortField) {
        info.sortField = info.defaultPlan.sortField.map(item => {
            if (preSortFiledMap[item.refcode]) {
                let ordertype = preSortFiledMap[item.refcode].ordertype;
                let _checked = preSortFiledMap[item.refcode]._checked;
                return { ...item, ordertype, _checked };
            }
            let _checked = item.ordertype === '0' ? false : item._checked ?? true;
            return { _checked, ...item };
        });
    } else {
        if(!updateSortField){
            info.sortField = [];
        }
    }
    //准备更新之前的查询区快照 首次渲染的时候没有
    let preSnap = currentPlan.renderobj4web_snap;
    let preSnapValueMap = {};
    //记录之前快照的value
    if (preSnap) {
        preSnap.forEach((item, index) => {
            preSnapValueMap[item.attrcode] = item.initialvalue;
        });
    }
    let isDefaultPlan = currentPlan.pk_ncc_queryscheme == '001';
    if (preSnap && flag) {
        //非首次
        if (isEdit) {
            //改没改模板
            /* 查询区逻辑：当领域通过代码或者字段控制规则控制字段显隐性的场景规则如下
1 以当前视图逻辑为基础，当有字段增加的时候，在当前视图后面增加，当有字段减少的时候，删除默认条件的字段，形成新的视图。
2 用户拖进来的字段值和显隐性，不受代码和字段控制规则控制。*/
            
            const templateDefault = [...currentPlan.renderobj4web].filter(item => info.itemsMap[item.attrcode] && item.isdefault != false);
            let newlist = [];
            preSnap.forEach(item => {
                if(item.isdefault != false){//来源是查询模板的默认显示的条件，不是用户手托的
                    let p = -1;
                    templateDefault.forEach((t, i) => {
                        if(t.attrcode == item.attrcode){
                            p = i;
                        }
                    });
                    if(p === -1){
                        return;
                    }
                    templateDefault.splice(p, 1);
                    
                }
                newlist.push(item);
            });
            newlist = [...newlist, ...templateDefault];

            let newFixed = info.fixedConditionGroup.filter(item => {
                return !newlist.find(v => v.attrcode == item.attrcode);
            }) || [];

            let normalSnap = [...newFixed, ...newlist];
            currentPlan.renderobj4web_snap = spreadQueryPlan(context, normalSnap, info.itemsMap, info.isWidgetMode);
            // currentPlan.renderobj4web_snap = spreadQueryPlan(context, currentPlan.renderobj4web, info.itemsMap, info.isWidgetMode, preSnapValueMap);s
        }

    } else {
        //这块逻辑是首次渲染
        if (isDefaultPlan) {
            //模板方案
            currentPlan.renderobj4web_snap = spreadQueryPlan(context, info.defaultPlan.renderobj4web, info.itemsMap, info.isWidgetMode);
        } else {
            if (currentPlan.renderobj4web && currentPlan.renderobj4web.length && currentPlan.renderobj4web[0].refpk === 'root') {
            //高级
                currentPlan.renderobj4web[0].visible = true;
                let superSnap = [...info.fixedConditionGroup, ...currentPlan.renderobj4web[0].children];
                let currentPlanCopy = _clone(currentPlan);
                currentPlanCopy.renderobj4web[0].children = superSnap;
                currentPlan.renderobj4web_snap = spreadQueryPlan(context, currentPlanCopy.renderobj4web, info.itemsMap, info.isWidgetMode);
            } else {
            //普通
                let filterFix = Array.isArray(currentPlan.renderobj4web) ? currentPlan.renderobj4web.filter(item => {
                    let fixCondition = info.fixedConditionGroup.find(a => a.attrcode == item.attrcode);
                    if (fixCondition) {
                        return false;
                    } else {
                        return true;
                    }
                }) : [];
                let normalSnap = [...info.fixedConditionGroup, ...filterFix];
                currentPlan.renderobj4web_snap = spreadQueryPlan(context, normalSnap, info.itemsMap, info.isWidgetMode);
            }
        }
    }

}

// 根据模板为查询区提供默认的 条件组的初始值
export function initDefaultSnapshot(items, context, isTemplateOrder, isWidgetMode) {
    let requireList = [];
    let fiexedList = [];
    let otherList = [];
    let snapshotList = [];
    if (isArray(items)) {[];
        snapshotList = items.filter(item => (item.visible || isWidgetMode) && item.isdrag);
        snapshotList.forEach((item, index) => {
            if (!(Number(item.visibleposition) > 0)) {
                item.visibleposition = 99999 + index;
            }
            if (item.isfixedcondition) {
                fiexedList.push(item);
            } else if (item.required) {
                requireList.push(item);
            } else {
                otherList.push(item);
            }
        });
        /**

         * 预置方案排序规则：查询模板中字段的排序分为“默认显示字段排序”、查询区域字段顺序、必填项顺序、固定条件顺序
排序规则：固定条件顺序>必填项顺序>默认显示字段排序中设置的顺序>查询区域字段顺序
举例：1.当一个字段设置了“默认显示字段排序”为10，在查询区域中字段显示在第12个，则在查询模板中此字段显示在第10的位置；
           2.当一个字段设置了“默认显示字段排序”为10，在查询区域中字段显示在第8个，又设置了固定条件，则此字段在查询模板中显示在第1位；
         */
        fiexedList.sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
        if (isTemplateOrder) {
            const notFixed = requireList.concat(otherList).sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
            snapshotList = fiexedList.concat(notFixed);
        } else {
            requireList.sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
            otherList.sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
            snapshotList = fiexedList.concat(requireList).concat(otherList);
        }
    }
    return { fiexedList, visibleItem: snapshotList };
}
//方案平铺
export function planExtend(searchInfo, items, context, result = [], level = 0) {
    if (Array.isArray(items)) {
        items.forEach(item => {
            if (item.children) {
                planExtend(searchInfo, item.children, context, result, ++level);
            } else {
                let initialvalue = {
                    display: '',
                    value: '',
                };
                item.initialvalue = item.initialvalue || item.value;
                let tempItem = searchInfo.itemsMap[item.attrcode];
                if (tempItem) {
                    if (tempItem.itemtype === 'checkbox_switch') {
                        if (initialvalue.value) {
                            initialvalue.value = true;
                        } else {
                            initialvalue.value = false;
                        }
                    } else if (tempItem.itemtype === 'refer' && item.initialvalue) {
                        let refervalue = getFunctionValueFromViewModal(item.initialvalue, context, tempItem.attrcode);
                        item.initialvalue.display = refervalue.display || item.initialvalue.display;
                    } else if (tempItem.itemtype === 'residtxt') {
                        let index = tempItem.languageMeta.filter(val => val.languageCode == localeLang)[0]?.index || 1;
                        initialvalue.index = index;
                        if (item.initialvalue && !item.initialvalue.hasOwnProperty('index')) {
                            item.initialvalue.index = index;
                        }
                    }
                    let obj = {
                        attrcode: item.attrcode,
                        refpk: item.attrcode,
                        initialvalue:
                            item.initialvalue &&
                                (item.initialvalue.value || item.initialvalue.value === false || item.initialvalue.display || item.initialvalue.index)
                                ? item.initialvalue
                                : initialvalue, //此处initialvalue判空可能有问题，调试的时候再改 xuyang
                        operationSign: item.operationSign || (item.queryOperateType && item.queryOperateType.split('@')[0]) || '',
                        remove: item.hasOwnProperty('remove')
                            ? item.remove
                            : tempItem.required != true && tempItem.isfixedcondition != true && tempItem.nodelete != true,
                        visible: true,
                    };
                    if (tempItem.itemtype === 'refer') {
                        obj.runWithChildren = !!item.runWithChildren;
                        obj.refurl = item.refurl || '';
                    } else if (tempItem.itemtype === 'residtxt') {

                        obj.valueMap = {};
                        if (!item.hasOwnProperty('valueMap') && obj.initialvalue.value) {
                            obj.valueMap[item.attrcode + obj.initialvalue.index] = { value: obj.initialvalue.value };
                        } else if (item.hasOwnProperty('valueMap')) {
                            obj.valueMap = item.valueMap;
                        }

                    }
                    if (tempItem.isfixedcondition && level < 2) {
                        obj.visible = false;
                    }
                    result.push(obj);
                }
            }
        });
    }
    return result;
}
// 将查询方案转换成 snapshot
export function plan2snapshotTranslate(itemsMap, items, context, preSnapMap = {}, level = 0) {
    if (Array.isArray(items)) {
        items.forEach(item => {
            if (item.children) {
                item.children = plan2snapshotTranslate(itemsMap, item.children, context, preSnapMap, ++level);
            } else {
                let initialvalue = {
                    display: '',
                    value: '',
                };
                if (preSnapMap[item.attrcode]) {
                    item.initialvalue = preSnapMap[item.attrcode];
                }
                item.initialvalue = item.initialvalue || item.value;
                let tempItem = itemsMap[item.attrcode];
                if (tempItem) {
                    if (tempItem.itemtype === 'checkbox_switch') {
                        initialvalue.value = false;
                    } else if (tempItem.itemtype === 'refer' && item.initialvalue) {
                        let refervalue = getFunctionValueFromViewModal(item.initialvalue, context, tempItem.attrcode);
                        item.initialvalue.display = refervalue.display || item.initialvalue.display;
                    } else if (tempItem.itemtype === 'residtxt') {
                        let index = tempItem.languageMeta.filter(val => val.languageCode == localeLang)[0]?.index || 1;
                        initialvalue.index = index;
                        if (item.initialvalue && !item.initialvalue.hasOwnProperty('index')) {
                            item.initialvalue.index = index;
                        }
                    }

                    item.refpk = item.refpk || item.attrcode;
                    item.initialvalue =
                        item.initialvalue &&
                            (item.initialvalue.value || item.initialvalue.value === false || item.initialvalue.display || item.initialvalue.index)
                            ? item.initialvalue
                            : initialvalue; //此处initialvalue判空可能有问题，调试的时候再改 xuyang
                    item.operationSign = item.operationSign || (tempItem.queryOperateType && tempItem.queryOperateType.split('@')[0]) || '';
                    item.operationOptions = createOperation(tempItem.queryOperateType);
                    item.remove = item.hasOwnProperty('remove')
                        ? item.remove
                        : tempItem.required != true && tempItem.isfixedcondition != true;
                    if (tempItem.itemtype === 'residtxt' && !item.hasOwnProperty('valueMap') && item.initialvalue.value) {
                        item.valueMap = {};
                        item.valueMap[item.attrcode + item.initialvalue.index] = { value: item.initialvalue.value };
                    }
                    item.visible = item.visible === false ? false : true;
                    //需要注释掉
                    // item.visible = !(!item.isfixedcondition && tempItem.isfixedcondition && level < 2);
                } else {
                    item.visible = false;
                }
            }
        });
        return items.filter(item => item.visible !== false);
    }
    return [];
}
//根据快照 过滤模板
export function templateFilter(itemsMap, snapshot) {
    let result = [];
    if (isArray(snapshot)) {
        snapshot.forEach(item => {
            if (itemsMap.hasOwnProperty(item.attrcode)) {
                result.push(itemsMap[item.attrcode]);
            }
        });
    }
    return result;
}

// 获得有数据的snapshot
export function snapshotFilter(snapshot, itemsMap) {
    if (Array.isArray(snapshot)) {
        return snapshot.filter(item => {
            return !isEmpty(item.initialvalue.value);
        });
    } else {
        return [];
    }
}
//查询条件所有值都添加了
export function allItemsFillComplete(snapshot, searchInfo, context) {
    let result = true;
    if (snapshot[0] && snapshot[0].attrcode == 'root') {
        snapshot = planExtend(searchInfo, snapshot, context);
    }
    snapshot.forEach(item => {
        let val = item.initialvalue;
        // 必填项无值 不执行查询 其他情况执行查询
        if (searchInfo.itemsMap[item.attrcode]['itemtype'] === 'refer') {
            val = getFunctionValueFromViewModal(item.initialvalue, context, item.attrcode);
        }
        if (searchInfo.itemsMap[item.attrcode]['required'] && isEmpty(val.value)) {
            result = false;
        }
    });
    return result;
}
//树结构转数组
export function tree2Array(data, reuslt = []) {
    if (Array.isArray(data)) {
        data.forEach(item => {
            if (item) {
                if (item.children) {
                    tree2Array(item.children, reuslt);
                } else {
                    reuslt.push(item);
                }
            }
        });
    }
    return reuslt;
}
//时间比较函数
export function CompareDate(d1, d2) {
    // console.log(d1, d2);
    return new Date(d1.replace(/-/g, '/')) > new Date(d2.replace(/-/g, '/'));
}
export function isDateFunction(value) {
    value = String(value);
    return value.indexOf('#') !== -1;
}

function addMark(data) {
    data.map(item => {
        if (
            item.initialvalue &&
            (item.initialvalue.value === '' ||
                item.initialvalue.value === null ||
                (isArray(item.initialvalue.value) && !item.initialvalue.value.length) ||
                (isArray(item.initialvalue.value) && item.initialvalue.value[0] === null))
        ) {
            item.isEmpty = true;
        } else {
            item.isEmpty = false;
        }
        if (Array.isArray(item.children)) {
            addMark(item.children);
        }
    });
}

/**
 * @description: 后台交互AJAX
 * @param {flag} String 交互类型 (edit编辑方案名称, save保存方案, add新增方案)
 * @param {type} Boolean 是否外层调用  
 * @param {currentPlan} String 传入需要处理的方案
 * @param {searchPlanName} 多语结构 需要处理的查询方案多语名称
 * @return: 
 */
//新增的时候传一个isquicks:true或者false，代表是不是设置默认
export function beSureBtnClick(flag, type, currentPlan, searchPlanName, isquicks, sortField, scope, enter, searchPlanMultiName, isShowInTable) {
    let currentPlanName = currentPlan.name;//要修改的方案的名称
    const searchInfo = this.state.searchInfo;
    let searchPlan = searchInfo.searchPlanCache;
    let multiLang = this.state.json;
    let returnFlag = false;
    let currentPlanName123 = searchInfo.multiLangOpt.createName123(currentPlan, true);
    if(!searchPlanName){
        searchPlanName = searchInfo.multiLangOpt.getMultiLangValueFromName123(currentPlanName123);
    }

    //保存方案添加appcode、pagecode
    let appReqParam = getAppReqParam();
    let appcode = appReqParam.appcode;
    let pagecode = appReqParam.pagecode;

    // if(this.props.meta && this.props.meta.cutsomPageCode){
    //     pagecode = this.props.meta.cutsomPageCode;
    // }
    if(this.props.customAppCode && this.props.customPageCode){
        appcode = this.props.customAppCode;
        pagecode = this.props.customPageCode;
    }

    /**
     * 当flag为save时只需要判断是不是预置方案就可以；
     * 方flag为edit和add时要判断名称不能为空，不能和其他方案的名字相同
     * 当flag为edit时修改的名字和之前一样时直接return并关闭修改弹窗
     */

    if (flag === 'save') {
        if (currentPlan.isshared === true) {
            toast({ content: multiLang['page-search-0144'], color: 'warning' });
            return;
        }
        if (currentPlan.isprepared === true) {
            toast({ content: multiLang['page-search-0016'], color: 'warning' });
            return;
        }
    } else if (flag === 'edit' || flag === 'add') {
        //这里的逻辑是在编辑方案模式下，如果编辑的方案名称和之前一样，则直接return并关闭修改弹窗
        if (flag === 'edit' && searchInfo.multiLangOpt.multiLagValueAndName123IsSame(searchPlanName, currentPlanName123)) {

            if (!type) {
                if(isShowInTable){
                    this.props.modal.close('editTableSearchName@' + this.props.moduleId);
                }else{
                    this.props.modal.close('editSearchPlanName@' + this.props.moduleId);
                }
            }else{
                this.props.modal.close('outAddSearchPlan@' + this.props.moduleId);
            }
            return;
        }
        //如果名字为空
        if (searchInfo.multiLangOpt.isEmpty(searchPlanName)) {
            toast({ content: multiLang['page-search-0032'], color: 'warning' });
            returnFlag = true;
        } 
        //如果重名
        const msg = searchInfo.multiLangOpt.checkDuplicateName(searchPlanName, searchPlan, currentPlan, flag);
        if(msg){
            toast({ content: multiLang['page-search-0083'] + ":" + msg, color: 'warning' });
            returnFlag = true;
        }
        if (returnFlag) {

            if (type) {
                this.props.modal.show('outAddSearchPlan@' + this.props.moduleId);
            } else {
               
                if(isShowInTable){
                    this.props.modal.show('editTableSearchName@' + this.props.moduleId);
                }else{
                    if(flag === 'add' ){
                        this.props.modal.show('addSearchPlan@' + this.props.moduleId);
                    }
                    if(flag === 'edit' ){
                        this.props.modal.show('editSearchPlanName@' + this.props.moduleId);

                    }
                }
            }
            return;
        }
    }

    let that = this;
    let data = {
        public: null, // 公共区域查询条件
        nonpublic: null, // 非公共区域查询条件
    };
    let state = null;

    /*
    *    如果业务组自定义查询条件，保存方案时，需要业务组返回其自定义的查询条件
    *    状态：
    *    1、业务组只添加部分自定义查询条件，此时分两部分：公共查询区、自定义查询区
    *    2、业务组替换整个右侧body区，只有自定义查询区
    *    3、只有公共查询区
    * */

    // 获取公共查询区域查询条件及state
    let runThis = () => {
        let searchInfo = this.state.searchInfo;
        data.public = _getAllSearchData(searchInfo, false);
        if (searchInfo.status == 'super') {
            let child = searchInfo.snapshotMap.super[0].children.filter(item => item.isExtend !== true);
            state = [{ ...searchInfo.snapshotMap.super[0], children: child }];
        } else {
            state = searchInfo.snapshotMap[searchInfo.status].filter(item => item.isExtend !== true); //这块有问题xuyangt
        }

        addMark(state);
    };
    if (flag === 'save' || flag === 'add') {
        if (this.state.userControlAll) {
            // 业务组替换整个查询区
            data.nonpublic = this.props.saveSearchPlan();
        } else {
            data.nonpublic = typeof this.props.saveSearchPlan === 'function' ? this.props.saveSearchPlan() : null;
            runThis();
        }
    }

    let saveSearchPlanData = {
        pk_ncc_queryscheme: '',
        conditionobj4web: data, //查询条件
        renderobj4web: state, // 查询条件前台数据结构，用于渲染查询区
        areaid: this.props.oid || this.props.meta.oid,
        isprepared: false, //预制方案
        isquickqs: false, //默认方案 ,只能修改，不能删除
        sortfield: sortField,
        appcode,
        pagecode,
        labelName:this.state.searchInfo.multiLangOpt.getCurrentLanguageValueFromMultiLangValue(searchPlanName),
        isMyPlan:true,
        areacode :this.state.searchInfo.moduleId
        
    };
    Object.assign(saveSearchPlanData, this.state.searchInfo.multiLangOpt.getName123FromMultiLagValue(searchPlanName));

    if (currentPlan) {
        saveSearchPlanData.pk_ncc_queryscheme = currentPlan.pk_ncc_queryscheme;
        saveSearchPlanData.isprepared = currentPlan.isprepared;
        saveSearchPlanData.isquickqs = currentPlan.isquickqs;
        saveSearchPlanData.isdelete = currentPlan.isdelete;
    }

    // editAjax 修改方案名称
    let editAjax = () => {
        let newdate = currentPlan;
        saveSearchPlanData.renderobj4web = newdate.renderobj4web;
        saveSearchPlanData.pk_ncc_queryscheme = newdate.pk_ncc_queryscheme;
        saveSearchPlanData.conditionobj4web = newdate.conditionobj4web || data;

        saveAjax();
    };
    // saveAjax 修改方案保存
    let saveAjax = () => {
        // setTimeout(() => {
        Ajax({
            url: '/nccloud/riart/queryscheme/updateQS.do',
            data: saveSearchPlanData,
            loading: false,
            success: res => {
                if (res.success) {
                    {
                        toast({ content: multiLang['page-search-0033'], color: 'success' });
                    }
                    // 修改成功后，更新state数据
                    if (type == true) {
                        // 外部修改 
                        let i = that.state.searchInfo.searchPlanCache.findIndex(
                            e => e.pk_ncc_queryscheme === saveSearchPlanData.pk_ncc_queryscheme,
                        );
                        if (i !== -1) {
                            //更新searchPlanCache

                            saveSearchPlanData.pk_ncc_queryscheme = res.data;

                            that.state.searchInfo.searchPlanCache[i] = _clone({
                                ...that.state.searchInfo.searchPlanCache[i],
                                ...saveSearchPlanData,
                            });
                            if (currentPlanName == that.state.searchInfo.currentPlan.name) {
                                that.state.searchInfo.currentPlan = saveSearchPlanData;
                            }
                            //更新模板数据
                            that.searchPlanCacheChange(that.state.searchInfo.searchPlanCache);
                            let keySessionS = this._this.myState.search.keySessionS;
                            if (!isEmpty(keySessionS)) {
                                keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                            }

                        }
                        return;
                    }
                    // enter 键 关闭modal 
                    if (typeof enter === 'object' && enter.type === 'keydown') {
                        if(isShowInTable){
                            this.props.modal.show('editTableSearchName@' + this.props.moduleId);
                        }else{
                            this.props.modal.show('editSearchPlanName@' + this.props.moduleId);
                        }
                    }
                    // 内部修改
                    let i = that.state.searchInfo.searchPlanCache.findIndex(
                        e => e.pk_ncc_queryscheme === saveSearchPlanData.pk_ncc_queryscheme,
                    );
                    if (i !== -1) {
                        delete that.state.searchInfo.searchPlanCache[i].renderobj4web_snap;
                        that.state.searchInfo.searchPlanCache[i] = _clone({
                            ...that.state.searchInfo.searchPlanCache[i],
                            ...saveSearchPlanData,
                        });
                        //更新模板数据
                        that.searchPlanCacheChange(that.state.searchInfo.searchPlanCache);
                    }
                    const name123 = that.state.searchInfo.multiLangOpt.createName123(saveSearchPlanData);
                    scope.setState({ currentPlan: that.state.searchInfo.searchPlanCache[i], searchPlanName:that.state.searchInfo.multiLangOpt.getMultiLangValueFromName123(name123) });
                    //如果内部正在修改的方案和外部显示的一样，更新外部的方案
                    if (that.state.searchInfo.currentPlan.pk_ncc_queryscheme === saveSearchPlanData.pk_ncc_queryscheme) {
                        let a = _clone(that.state.searchInfo.searchPlanCache[i]);
                        scope.props.upDateSearchPlan(a);
                    }
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                    }
                }
            },
        });
        // }, 100);

    };

    let addAjax = () => {
        /* 避免新增方案时有pk */
        if (saveSearchPlanData.hasOwnProperty('pk_ncc_queryscheme')) {
            delete saveSearchPlanData.pk_ncc_queryscheme;
        }
        saveSearchPlanData.isquickqs = false;
        saveSearchPlanData.isprepared = false;
        saveSearchPlanData.isdelete = false;
        saveSearchPlanData.visible = true;
        

        saveSearchPlanData.sequenc =
            ((Array.isArray(this.state.searchInfo.searchPlanCache) && this.state.searchInfo.searchPlanCache.length) || 0) + 1;
        // setTimeout(() => {
        Ajax({
            url: '/nccloud/riart/queryscheme/addQS.do',
            data: { nccQS: JSON.stringify(saveSearchPlanData), isDefaultDisplay: isquicks, appcode, pagecode },
            success: res => {
                if (res.success) {
                    {
                        toast({ content: multiLang['page-search-0034'], color: 'success' });
                    }
                    // enter 键 关闭modal 
                    if (typeof enter === 'object' && enter.type === 'keydown') {
                        if (type === true) {
                            this.props.modal.close('outAddSearchPlan@' + this.props.moduleId);
                        } else {
                            this.props.modal.close('addSearchPlan@' + this.props.moduleId);
                        }
                    }
                    saveSearchPlanData.pk_ncc_queryscheme = res.data;
                    // saveSearchPlanData.pk_ncc_queryscheme = 'res.data' + Math.random();
                    const queryschemes = this.state.searchInfo.searchPlanCache;
                    //这里的searchPlanCache里面各查询方案的idefault没更新
                    this.state.searchInfo.searchPlanName = {};
                    //如果将新建的方案设为默认，那就将其他的isdefault都设为false
                    if (isquicks) {
                        this.props.meta.defaultDisPlay = res.data;
                    }

                    queryschemes.push(_clone(saveSearchPlanData));
                    //更新模板数据
                    this.searchPlanCacheChange(queryschemes);
                    scope.setState({ checked: false });
                    if (type) {
                        this.chooseSearchPlan(saveSearchPlanData, false);
                    } else {
                        scope.clickSearchPlan(saveSearchPlanData);
                    }
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                    }
                }
            },
        });
        // }, 100);

    };

    if (flag === 'edit') {
        //修改方案名称
        editAjax();
    } else if (flag === 'save') {
        // 直接保存 
        saveAjax();
    } else if (flag === 'add') {
        //添加新方案
        addAjax();
    }
}

/* 删除查询方案确定按钮 */
export function beSureBtnClick_Del(type, pk_ncc_queryscheme, scope) {
    // let pk = null;
    let that = this;
    // if (typeof type == 'boolean') {
    //     this.props = this;
    const multiLang = this.state.json;
    //     pk = pk_ncc_queryscheme;
    // } else {
    //     pk = this.state.currentPlan.pk_ncc_queryscheme;
    // }
    // setTimeout(() => {

    //如果是预置方案，不执行删除，toast提示
    if(!Array.isArray(pk_ncc_queryscheme)){
        let preparedPlan = this.state.searchInfo.searchPlanCache.find(item => item.pk_ncc_queryscheme === pk_ncc_queryscheme);
        if(preparedPlan && preparedPlan.isprepared){
            toast({ content: multiLang['page-search-0163'], color: 'warning' });
            return;
        }
    }

    let param = [];
    if(Array.isArray(pk_ncc_queryscheme)){
        pk_ncc_queryscheme.forEach(item => {
            param.push({ pk_ncc_queryscheme:item });
        });
    }else{
        param.push({ pk_ncc_queryscheme:pk_ncc_queryscheme });
    }
    Ajax({
        url: '/nccloud/platform/templet/deleteQueryScheme.do',
        data: param,
        success: res => {
            if (res.success) {
                {
                    toast({ content: multiLang['page-search-0038'], color: 'success' });
                }
                const quickqs = this.state.searchInfo.searchPlanCache.find(item => item.isquickqs);
                //如果删除的是默认方案
                // if((Array.isArray(pk_ncc_queryscheme))){
                //     if (quickqs && pk_ncc_queryscheme.includes(this.props.meta.defaultDisPlay)) {
                //         this.props.meta.defaultPrepared = quickqs.pk_ncc_queryscheme;
                //         this.props.meta.defaultDisPlay = undefined;
                //     }
                // }else{
                //     if (quickqs && this.props.meta.defaultDisPlay === pk_ncc_queryscheme) {
                //         this.props.meta.defaultPrepared = quickqs.pk_ncc_queryscheme;
                //         this.props.meta.defaultDisPlay = undefined;
                //     }
                // }

                // 外部修改
                if (type) {
                    if((Array.isArray(pk_ncc_queryscheme))){
                        this.state.searchInfo.searchPlanCache = this.state.searchInfo.searchPlanCache.filter(item => !(pk_ncc_queryscheme.includes(item.pk_ncc_queryscheme)));
                    }else{
                        this.state.searchInfo.searchPlanCache = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != pk_ncc_queryscheme);
                    }
                    // 修改模板的查询方案
                    this.props.meta.queryschemes = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != '001');
                    //如果删除的时当前选中的方案，就切换到快速查询方案或者预置方案
                    if((Array.isArray(pk_ncc_queryscheme))){
                        if ((this.state.searchInfo.currentPlan && pk_ncc_queryscheme.includes(this.state.searchInfo.currentPlan.pk_ncc_queryscheme))) {
                            // let quickqs = this.state.searchInfo.searchPlanCache.find(item => item.isquickqs);
                            if (quickqs) {
                                this.chooseSearchPlan(quickqs);
                            } else {
                                this.chooseSearchPlan(this.state.searchInfo.defaultPlan);
                            }
                        }
                    }else{
                        if ((this.state.searchInfo.currentPlan && this.state.searchInfo.currentPlan.pk_ncc_queryscheme) == pk_ncc_queryscheme) {
                            // let quickqs = this.state.searchInfo.searchPlanCache.find(item => item.isquickqs);
                            if (quickqs) {
                                this.chooseSearchPlan(quickqs);
                            } else {
                                this.chooseSearchPlan(this.state.searchInfo.defaultPlan);
                            }
                        }
                    }

                    //删除localstorage中的模板数据
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                    }
                    this.setState({ searchInfo: this.state.searchInfo });
                    return;
                }
                if((Array.isArray(pk_ncc_queryscheme))){
                    this.state.searchInfo.searchPlanCache = this.state.searchInfo.searchPlanCache.filter(item => !(pk_ncc_queryscheme.includes(item.pk_ncc_queryscheme)));
                }else{
                    this.state.searchInfo.searchPlanCache = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != pk_ncc_queryscheme);
                }
                
                // 修改模板的查询方案
                this.props.meta.queryschemes = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != '001');
                // let quickqs = this.state.searchInfo.searchPlanCache.find(item => item.isquickqs);
                if((Array.isArray(pk_ncc_queryscheme))){
                    if (pk_ncc_queryscheme.includes(scope.state.currentPlan.pk_ncc_queryscheme)) {
                        if (quickqs) {
                            scope.clickSearchPlan(quickqs);
                        } else {
                            scope.clickSearchPlan(this.state.searchInfo.defaultPlan);
                        }
                    }
                }else{
                    if (scope.state.currentPlan.pk_ncc_queryscheme === pk_ncc_queryscheme) {
                        if (quickqs) {
                            scope.clickSearchPlan(quickqs);
                        } else {
                            scope.clickSearchPlan(this.state.searchInfo.defaultPlan);
                        }
                    }
                }

                // 删除外部方案
                if((Array.isArray(pk_ncc_queryscheme))){
                    if (pk_ncc_queryscheme.includes(this.state.searchInfo.currentPlan && this.state.searchInfo.currentPlan.pk_ncc_queryscheme)) {
                        if (quickqs) {
                            scope.props.upDateSearchPlan(quickqs);
                        } else {
                            scope.props.upDateSearchPlan(this.state.searchInfo.defaultPlan);
                        }
                    }
                }else{
                    if (pk_ncc_queryscheme === (this.state.searchInfo.currentPlan && this.state.searchInfo.currentPlan.pk_ncc_queryscheme)) {
                        if (quickqs) {
                            scope.props.upDateSearchPlan(quickqs);
                        } else {
                            scope.props.upDateSearchPlan(this.state.searchInfo.defaultPlan);
                        }
                    }
                }

                //删除localstorage中的模板数据
                let keySessionS = this._this.myState.search.keySessionS;
                if (!isEmpty(keySessionS)) {
                    keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                }
                scope.setState({ currentPlan: quickqs || this.state.searchInfo.defaultPlan });
            }
        },
    });
    // }, 100);

}
//ajax参数 pk_ncc_queryscheme ; areaId; isNotQS
export function setDefaultScheme(type, currentPlan, pk_ncc_queryscheme, areaId, pk_queryscheme_share) {
    let appReqParam = getAppReqParam();
    let appcode = appReqParam.appcode;
    let pagecode = this.globalPageCode || appReqParam.pagecode;
    if(this.props.meta && this.props.meta.cutsomPageCode){
        pagecode = this.props.meta.cutsomPageCode;
    }

    if(this.props.customAppCode && this.props.customPageCode){
        appcode = this.props.customAppCode;
        pagecode = this.props.customPageCode;
    }

    const data = { areaId, appcode, pagecode, pk_old_default_queryscheme:this.props.meta.defaultDisPlay };
    //多个方案分享主键pk_queryscheme_share,从currentPlan中取
    if (pk_ncc_queryscheme === "001") {
        data.pk_ncc_queryscheme = '00000000000000000000';
    } else {
        data.pk_ncc_queryscheme = pk_ncc_queryscheme;
        data.pk_queryscheme_share = pk_queryscheme_share;
    }
    // setTimeout(() => {
    Ajax({
        url: '/nccloud/platform/templet/setDefaultQueryScheme.do',
        data: data,
        loading: false,
        success: res => {
            if (res.success) {
                // 外部修改
                if (type) {
                    this.props.meta.defaultDisPlay = pk_ncc_queryscheme;
                    //删除localstorage中的模板数据
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                    }
                    this.setState({ searchInfo: this.state.searchInfo });
                    return;
                }
            }
        },
        // }, 100);
    });
}

// 点击查询以后存储下当前查询条件 维度是 用户id + appCode + pageCode
export function setSearchCacheData({ moduleId, finalData, meta, callback, tableQuery }) {
    // // 从layout读取下 当前查询区有没有关联表格的空状态 没有就不用添加了
    // let { layout = '[]' } = meta;
    // layout = isJSON(layout) ? JSON.parse(layout) : [];
    // let flag = layout.some(item => item.props?.relationQuery === moduleId);
    // tableQuery 如果传入 tableQuery 标明已经从表格注册了空指引查询
    if (!tableQuery) { callback && callback?.(); return; }
    let appReqParam = getAppReqParam();
    let appcode = appReqParam.appcode;
    let pagecode = this.globalPageCode || appReqParam.pagecode;
    if(this.props.customAppCode && this.props.customPageCode){
        appcode = this.props.customAppCode;
        pagecode = this.props.customPageCode;
    }
    let searchTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
    let { oid, pk_queryhistory, querycondition, ...others } = finalData;
    let params = null;
    if (pk_queryhistory) {
        params = {
            pk_queryhistory,
            recordtime: searchTime,
        };
    } else {
        params = {
            appcode,
            pagecode,
            historytype: '1',
            areacode: moduleId,
            recordtime: searchTime,
            querycondition: JSON.stringify(querycondition),
            queryrelationinfo: JSON.stringify(others),
        };
    }
    if (appcode && pagecode) {
        setUserQueryHistory(params, callback);
    } else {
        callback && callback();
    }
}

// 根据日期item翻译成display值，如“昨日(2023年11月5日)”
export function getTimeFunctionValue(item){
    const multiLang = this.state.json;
    let searchInfo = this.state.searchInfo;
    let temItem = searchInfo.itemsMap[item.attrcode];
    let timeItemList = [
        'datepicker',
        'datetimepicker',
        'rangepicker',
        'NCTZDatePickerStart',
        'NCTZDatePickerEnd',
        'NCTZDatePickClientTime',
        'NCTZDatePickClientHourTime',
        'NCTZDatePickerRangeDay',
        'datePickerNoTimeZone',
    ];
    let valArr = [];
    let resultArr = [];
    let val = item.initialvalue.value;
    let operationSign = item.operationSign;
    let itemtype = item.itemtype;
    let isconverttimezones = item.isconverttimezones;
    let dateFlag = itemtype === 'datetimepicker' ? 'datetime' : 'date';
    let range = (operationSign === 'between' || operationSign === 'not between') ? true : false;
    let singleValue;
    if (itemtype === 'NCTZDatePickerEnd') {
        singleValue = 'end';
    } else if (itemtype === 'NCTZDatePickerStart') {
        singleValue = 'start';
    }
    if (val) {
        if (typeof val === 'string' && range) {
            valArr = val.split(',');
        } else if (Array.isArray(val)) {
            valArr = val;
        } else {
            valArr = [val];
        }
    }
    for (var i = 0; i < valArr.length; i++) {
        if (valArr[i] && timeItemList.includes(itemtype)) {
            if (valArr[i].indexOf('#') !== -1) {
                let timeValue = getFunctionDisplay(valArr[i], { ...temItem, range, multiLang, singleValue });
                if (range) {
                    timeValue[i] && resultArr.push(timeValue[i]);
                } else {
                    timeValue && resultArr.push(timeValue);
                }
            } else {
                resultArr.push(formatDatetime(serverTimeToLocal(moment(valArr[i]), isconverttimezones), dateFlag));
            }
        }
    }
    if (resultArr.length) {
        return resultArr.join(',');
    }
    return item.initialvalue.display;
}

// 比较两个值(基本类型值或对象）是否一样
export function compare(a, b) {
    if (typeof a === 'object' && typeof b === 'object') {
        if (a && b) {
            // 去掉undefined
            a = JSON.parse(JSON.stringify(a));
            b = JSON.parse(JSON.stringify(b));
            var akeys = Object.keys(a),
                bkeys = Object.keys(b);
            if (akeys.length === bkeys.length) {
                for (var i = 0, l = akeys.length; i < l; i++) {
                    var flag = compare(a[akeys[i]], b[akeys[i]]);
                    if (!flag) {
                        return false;
                    }
                }
                return true;
            } else {
                return false;
            }
        } else {
            return Object.is(a, b);
        }
    } else {
        return a == b;
    }
}

// 将数据存入缓存--命中缓存仍存数据的原因是缓存数据的顺序
export function setCacheData (url, param, data) {
    param = JSON.parse(JSON.stringify(param));
    data = JSON.parse(JSON.stringify(data));
    let cacheData = ViewModel.getData('searchSchemaCache') || [];
    let i = cacheData.findIndex(e => {
        return e.url === url && compare(param, e.param);
    });
    if (i > -1) {
        cacheData.splice(i, 1);
    }

    cacheData.push({
        url,
        param,
        data,
    });
    while (cacheData.length > maxCacheNum) {
        cacheData.shift();
    }
    ViewModel.setData('searchSchemaCache', cacheData);
}

// 是否命中缓存
export function hasCache (url, param) {
    let cacheData = ViewModel.getData('searchSchemaCache') || [],
        cache = cacheData.find(e => {
            return e.url === url && compare(param, e.param);
        });
    if (cache) {
        setCacheData(url, param, cache.data);
        return cache.data;
    } else {
        return null;
    }
}

export function sendAjax (url, param) {
    let cacheData = hasCache(url, param);
    if (cacheData) {
        //处理缓存数据
    } else {
        Ajax({
            url,
            data: param,
            loading: false,
            success: res => {
                if (!res.success) {
                    throw new Error(res.error.message);
                }
                if (res.data && res.data.message) {
                    toast({
                        color: 'warning',
                        content: res.data.message,
                    });
                }
                setCacheData(url, param, res.data);
            },
            error: e => {
                toast({
                    color: e.type || 'danger',
                    content: e.message,
                });
                // throw new Error(e);
            },
        });
    }
}
export class MultiLangOpt{
    constructor(mulitLangMetas){
        this.mulitLangMetas = mulitLangMetas || [];
        this.langseq = this.getLangseq();
        
    }
    createName123 = (obj = {}, nameIsName1) => {
        // 创建一个空对象来存储结果  
        const result = {};  
  
        // 使用Object.keys()遍历输入对象的所有键  
        Object.keys(obj).forEach(key => {  
        // 检查键是否以'name'开头  
            if (key.startsWith('name')) {  
            // 如果是，就将这个属性复制到结果对象中 
                if(nameIsName1 && key === 'name') {
                    result['name1'] = obj[key];   
                }else{
                    result[key] = obj[key];  
                }
               
            }  
        });  
  
        // 返回结果对象  
        return result;  

    }
    getLangseq (){
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA'),
        );
        //有可能 缓存里的 languageMetas 跟 context里的不一样
        const { languageMetas = [], langseq } = userData || {};
        const current = languageMetas.find(item => item.index == langseq) || {};
        const result = this.mulitLangMetas.find(item => item.languageCode === current.languageCode) || {};
        return result.index || '1';
    }
    getCurrentLanguageValueFromMultiLangValue =(multiLangValue = {}) => {
        return multiLangValue['name' + this.langseq]?.value;
    }
    getCurrentLanguageValueFromName123 = (name123 = {}) => {
        if(this.langseq == '1'){
            return name123.name;
        }else{
            return name123['name' + this.langseq];
        }

    }
    getMultiLangValueFromName123 = (name123 = {}) => {
        const result = {};
        Object.keys(name123).forEach(key => {
            let _key = key;
            let _value = name123[key];
            //如果是主语种
            if(key === 'name'){
                _key = 'name1';
                //如果主语种没值,那么把当前语种赋给主语种
                if(!_value){
                    _value = name123['name' + this.langseq];
                }
            }else{
                //如果当前语种没值，则把主语种给当前语种
                if('name' + this.langseq === key && !_value){
                    _value = name123['name'];
                }
            }
            
            result[_key] = { value:_value };
        });
        return result;

    }
    getName123FromMultiLagValue = (multiLangValue = {}) => {
        const result = {};
        Object.keys(multiLangValue).forEach(key => {
            let _key = key;
            let _value = multiLangValue[key].value;
            if(key === 'name1'){
                _key = 'name';
            }
            result[_key] = _value;
        });
        return result;

    }
    checkDuplicateName = (multiLangValue, schemaList, current, type = 'add') => {
        const pravteSchemaList = schemaList.filter(item => {
            if(item.isshared){
                return false;
            }else{
                if(type === 'edit'){
                    return item.pk_ncc_queryscheme !== current.pk_ncc_queryscheme;
                }
            }
            return true;
        } );

        const array = Object.keys(multiLangValue);

        let msg = "";
        for(let i = 0;i < array.length;i++){
            const name = multiLangValue[array[i]]?.value;
            if(name){
                for(let j = 0;j < pravteSchemaList.length;j++){
                    const schema = pravteSchemaList[j];
                    const name123 = this.createName123(schema, true);

                    Object.keys(name123).forEach(key => {
                        if(name123[key] === name){
                            this.mulitLangMetas.forEach(item => {

                                if(key.includes(String(item.index))){
                                    msg = item.languageType;
                                }
                            });

                        }
                    });
                    if(msg){
                        break;
                    }
                }
            }
            if(msg){
                break;
            }

        }
        return msg;

    }
    multiLagValueAndName123IsSame = (multiLangValue, name123) => {
        let result = true;
        Object.keys(multiLangValue).forEach(key => {
            if(multiLangValue[key].value !== name123[key] && result){
                result = false;
            }
        });
        return result;

    }
    isEmpty = multiLangValue => {
        let value1 = multiLangValue?.name1?.value || "";
        let value2 = multiLangValue?.['name' + this.langseq]?.value || "";
        return value1.replace(/\s+/g, '') === "" || value2.replace(/\s+/g, '') === "";

    }
    synchronousMultiLangValue = (multiLangValue, index) => {
        if(!multiLangValue?.name1?.value){
            if(!multiLangValue?.name1){
                multiLangValue.name1 = { value:"" };
            } 
            multiLangValue.name1.value = multiLangValue['name' + index].value;
        }
        if(!multiLangValue['name' + this.langseq].value){
            multiLangValue['name' + this.langseq].value = multiLangValue['name' + index].value;
        }
        return multiLangValue;
    }

}
export function uniqueArray(arr, key,isCover=false) {  
    const seen = new Map();  
    return arr.filter(item => {  
        // 判断是否为对象  
        if (typeof item === 'object' && item !== null) {  
            // 使用对象的key作为唯一标识  
            const itemKey = item[key];  
            if (seen.has(itemKey)) {  
                if(isCover){
                    seen.set(itemKey, true);  
                }
                return false;  
            } else {  
                seen.set(itemKey, true);  
                return true;  
            }  
        } else {  
            // 对于非对象，直接使用元素值作为唯一标识  
            if (seen.has(item)) {  
                if(isCover){
                    seen.set(item, true);  
                }
                return false;  
            } else {  
                seen.set(item, true);  
                return true;  
            }  
        }  
    });  
}  
export function autoSearchConfigOpt(type, moduleId, value){
    let appReqParam = getAppReqParam();
    let userData = JSON.parse(
        getGlobalStorage('localStorage', 'STOREFORINFODATA'),
    );
    let userId = (userData && userData.userId) || '';
    let appcode = appReqParam.appcode;
    let pagecode = appReqParam.pagecode;
    let searchKey = appcode + pagecode + userId + moduleId;
    let storeValue = JSON.parse(getGlobalStorage('localStorage', 'autoSearchConfig') || "{}") ;

    if(type === 'get'){
        return storeValue[searchKey];
    }else if(type === 'set'){
        storeValue[searchKey] = value;
        setGlobalStorage('localStorage', 'autoSearchConfig', JSON.stringify(storeValue));
    }
    
}

export function isEqual(value1, value2) {  
    // 如果两个值都是null或者undefined，认为它们相等  
    if (value1 === null || value2 === null) {  
        return value1 === value2;  
    }  
    
    // 如果两个值严格相等，直接返回true  
    if (value1 === value2) {  
        return true;  
    }  
    
    // 如果两个值类型不同，返回false  
    if (typeof value1 !== typeof value2) {  
        return false;  
    }  
    
    // 如果两个值都是对象或数组，递归比较它们的属性或元素  
    if (typeof value1 === 'object') {  
        // const keys1 = Object.keys(value1);  
        // const keys2 = Object.keys(value2);  
    
        // // 如果键的数量不同，返回false  
        // if (keys1.length !== keys2.length) {  
        //     return false;  
        // }  
    
        // // 递归比较每个键对应的值  
        // for (const key of keys1) {  
        //     if (!keys2.includes(key) || !isEqual(value1[key], value2[key])) {  
        //         return false;  
        //     }  
        // }  
    
        return true;  
    }  
    
    // 对于非对象、非数组的值，我们已经通过前面的比较处理了  
    return false;  
}  

function deepSelectiveEqual(obj1, obj2, compareFields) {
    // 获取两个对象的键  
    const keys1 = Object.keys(obj1);  
    const keys2 = Object.keys(obj2);  
    
    // 遍历第一个对象的键  
    for (const key of keys1) {  
        if(compareFields && !compareFields.includes(key)){
            continue;
        }
        // 检查这个键是否也存在于第二个对象中  
        if (keys2.includes(key)) {  
        // 如果存在，比较它们的值  
            if (!isEqual(obj1[key], obj2[key])) {  
            // 如果值不相等，返回false  
                return false;  
            }  
        }  
    }  
    
    // 如果所有检查都通过，返回true  
    return true;  
}
  
export function compareObjectArraysSelective(arr1, arr2, compareFields) {
    if (arr1.length !== arr2.length) {return false;}
  
    for (let i = 0; i < arr1.length; i++) {
        if (!deepSelectiveEqual(arr1[i], arr2[i], compareFields)) {
            return false;
        }
    }
  
    return true;
}
export function observe(target, observers) {  
    // 检查观察者配置，确保是对象且至少有一个属性  
    if (typeof observers !== 'object' || observers === null || Object.keys(observers).length === 0) {  
        throw new Error('Observers must be an object with at least one property defined.');  
    }  
  
    // 使用Proxy来劫持属性的get和set操作  
    return new Proxy(target, {  
        get(target, prop, receiver) {  
            // 检查是否有对应的get观察器  
            if (prop in observers && typeof observers[prop].get === 'function') {  
                // 执行get观察器  
                return observers[prop].get(target[prop], target, prop);  
            }  
            // 如果没有或不是函数，则直接返回属性值  
            return Reflect.get(target, prop, receiver);  
        },  
        set(target, prop, value, receiver) {  
            // 检查是否有对应的set观察器  
            if (prop in observers && typeof observers[prop].set === 'function') {  
                // 执行set观察器  
                const result = observers[prop].set(target, prop, value, receiver);  
                // 如果set观察器有返回值且为true，则更新属性值  
                if (result !== false) {  
                    Reflect.set(target, prop, value, receiver);  
                }
                return result; // 返回set观察器的结果  
            }  
            // 如果没有或不是函数，则直接设置属性值  
            return Reflect.set(target, prop, value, receiver);  
        },  
    });  
} 
